import { CommercialDocument } from './commercial-document';
export class CommercialDocumentLine {
    id: number = 0;
    commercial_document_id: number = 0;
    commercialDocument: CommercialDocument = new CommercialDocument();
    description:string = null;
    status: string = 'Activa';   
}
